import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
  ListGroup,
  ListGroupItem,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {getActiveAnnouncements} from '../../../redux/actions/announcementsActions';
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import moment from "moment";
import {
  renderAlert,
  clearAlert
} from "../../../redux/actions/alertsActions";
import Dialog from "react-bootstrap-dialog";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util";
import Toggle from "react-bootstrap-toggle";
import ReactHtmlParser from "react-html-parser";
import './Announcements.css'
const history = createBrowserHistory();
let isLoading = "false";
class AnnouncementsList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ANNOUNCEMENTS_LIST',
      announcementsList: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Announcements"],
      links: ["home", "announcements"],
      show: false,
      direction: "",
      orderBy: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(limit) {
    this.setState({
      limit: limit
    });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search
    };

    this.props.getActiveAnnouncements(postData);
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.getActiveAnnouncements(postData);
  };

  componentWillMount() {
    isLoading = "true";
    this.handleDismiss();
    this.props.clearAlert();
    this.props.getActiveAnnouncements({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.announcementsList !== nextProps.announcementsList) {
      if (nextProps.announcementsList) {
        const setPageCount =
          nextProps.announcementsList.total / nextProps.announcementsList.per_page;
        this.setState({
          announcementsList: nextProps.announcementsList.data,
          totalRecords: nextProps.announcementsList.total,
          perPage: nextProps.announcementsList.per_page,
          pageCount: setPageCount
        });
        isLoading = "false";
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let announcementsRow;
    let announcementsListData = this.state.announcementsList
      ? this.state.announcementsList
      : [];

    if (!isEmpty(announcementsListData)) {
      announcementsRow = announcementsListData.map((announcements, index) => (
        <ListGroupItem  key={announcements.announcementsID}>
          <h2 className="announcement_title">{announcements.title}</h2>
          <div class="date">
            <span className="announcement_start">
              {(announcements.start_date) ? moment(announcements.start_date).format("ll") : ""}
            </span>
            <span>-</span>
            <span className="announcement_end">
              {(announcements.end_date) ? moment(announcements.end_date).format("ll") : ""}
            </span>
          </div>
          <div className="announcement_desc">
            {announcements.description ? ReactHtmlParser(announcements.description): ""}
          </div>
            
        </ListGroupItem>
      ));
    }else{
      announcementsRow = <ListGroup><ListGroupItem>Data Not Found</ListGroupItem></ListGroup>
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                <ListGroup className="active_announcement">
                  {announcementsRow}
                </ListGroup>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AnnouncementsList.propTypes = {
  getActiveAnnouncements: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  announcementsList: state.announcementsReducer.announcementsList,
  error: state.announcementsReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  getActiveAnnouncements,
  renderAlert,
  clearAlert
})(AnnouncementsList);



// WEBPACK FOOTER //
// ./src/app/views/admin/announcements/AnnouncementsList.js